import JSONModel from "sap/ui/model/json/JSONModel";
import { MainContractForWorkOrderDto } from "../models/MainContractForWorkOrderDto";
import CheckBox, { CheckBox$SelectEvent } from "sap/m/CheckBox";
import { GetController } from "./CustomControlUtil";
import { WorkOrderMainContractLogicController } from "../pages/sharedControllers/WorkOrderMainContractLogicController";
import CustomComboBox from "../customControls/CustomComboBox";
import { IsUserAdmin } from "../services/AuthService";

export function UpdateContractInfoOnChange(
  controller: WorkOrderMainContractLogicController
) {
  let mainContract: boolean =
    controller.getModel("noMainContract")?.getProperty("/value") ?? false;

  const ccB = controller.byId("mainContractId") as CustomComboBox;
  const selectedItem = ccB
    .getItems()
    ?.find((item) => item.getKey() == ccB.getSelectedKey());
  const contractData =
    (selectedItem
      ?.getBindingContext("mainContractOptions")
      ?.getProperty("") as MainContractForWorkOrderDto) ?? undefined;

  let model: JSONModel | undefined;
  if (!mainContract) {
    model = controller.getModel("mainContractDisplay");

    const mainModel = controller.getModel();
    handleInstallationAddressAutofill(
      mainModel,
      mainModel?.getProperty("/installationAddress"),
      model?.getProperty("/address"),
      contractData
    );

    if (model) {
      model?.setProperty("/address", contractData?.address);
      model?.setProperty("/buyerName", contractData?.buyerName);
      model?.setProperty("/sapId", contractData?.sapId);
    } else {
      controller.setModel(new JSONModel(contractData), "mainContractDisplay");
    }
  } else {
    model = controller.getModel();

    handleInstallationAddressAutofill(
      model,
      model?.getProperty("/installationAddress"),
      model?.getProperty("/mainContract/address"),
      contractData
    );

    model?.setProperty("/mainContract/address", contractData?.address);
    model?.setProperty("/mainContract/buyerName", contractData?.buyerName);
    model?.setProperty("/mainContract/sapId", contractData?.sapId);
  }
}

function handleInstallationAddressAutofill(oModel: JSONModel | undefined, installationAddress: string, mainContractAddress: string | undefined, contractData: MainContractForWorkOrderDto) {
  // if installation address was set by user it is assumed to be different from any selected main contract address so it is left as is.
  // if installation address was empty then it is set to be same as main contract address and when user deselects a main contract it is also wiped
  if (!installationAddress || installationAddress === mainContractAddress)
    oModel?.setProperty("/installationAddress", contractData?.address);
}

export function UpdateContractInfoOnLoad(
  controller: WorkOrderMainContractLogicController,
  mainContract: MainContractForWorkOrderDto | null
) {
  if (!mainContract) return;

  const isUserAdmin = IsUserAdmin();
  controller.setModel(new JSONModel({ value: isUserAdmin }), "isUserAdmin");
  controller.setModel(new JSONModel({ value: true }), "noMainContract");
  SetOnlyMyContractsSelected(controller, mainContract.doesBelongToUser);

  controller.setModel(new JSONModel(mainContract), "mainContractDisplay");
}

export function SetOnlyMyContractsSelected(
  controller: WorkOrderMainContractLogicController,
  value: boolean
) {
  (controller.byId("only-my-contracts-checkbox") as CheckBox).setSelected(
    value
  );

  UpdateMainContractOptions(controller, value);
}

async function UpdateMainContractOptions(
  controller: WorkOrderMainContractLogicController,
  isOnlyMine: boolean
): Promise<MainContractForWorkOrderDto[]> {
  const selectData = await controller._workOrderSelectDataPromise;

  const mainContractOptions = isOnlyMine
    ? selectData.userContracts
    : selectData.allContracts;

  controller.setModel(
    new JSONModel(mainContractOptions),
    "mainContractOptions"
  );

  return mainContractOptions;
}

export async function ToggleOnlyMyContracts(event: CheckBox$SelectEvent) {
  let isSelected = event.getParameter("selected");
  const controller = GetController(
    event.getSource()
  ) as WorkOrderMainContractLogicController;
  const mainContractOptions = await UpdateMainContractOptions(
    controller,
    !!isSelected
  );

  const selectedContractIdStr = controller
    .getModel()
    .getProperty("/mainContract/contractId");

  if (
    selectedContractIdStr &&
    !mainContractOptions.some(
      (co) => co.contractId == Number(selectedContractIdStr)
    )
  ) {
    controller.getModel().setProperty("/mainContract", {});
    controller.setModel(new JSONModel(), "mainContractDisplay");
  }
  if (!isSelected) {
    await UpdateContractInfoOnChange(controller);
  }
}
